<template>
  <div class="tusd-wrap wrap-bg">
  	<div class="page-title">市场</div>
  	<cube-scroll-nav-bar :current="currentStatus" :labels="status" :txts="txts" @change="changeNav" />
  	<div class="separator"></div>
	<div class="search" v-if="currentStatus == 1">
		<div class="search_item" style="width: 98%;">
			<cube-select
				@change="getOrders(1)"
				v-model="searchForm.payType"
				placeholder="请选择支付方式"
				:options="payTypeOptions">
			</cube-select>
		</div>
		<div class="search_item">
			<cube-input type="number" v-model="searchForm.minCNY" placeholder="最小金额（CNY）" @change="getOrders(1)"></cube-input>
		</div>
		<div class="search_item">
			<cube-input type="number" v-model="searchForm.maxCNY" placeholder="最大金额（CNY）" @change="getOrders(1)"></cube-input>
		</div>
	</div>
	<div class="separator" v-if="currentStatus == 1"></div>
  	<cube-slide class="order-scroll" :options="{click:false}" :showDots="false" :initialIndex="crtIndex" :autoPlay="false" :loop="false" @change="changeSlide">
	    <cube-slide-item>
	      	<cube-scroll ref="scrollF" :data="order" :options="scrollOptions" @pulling-down="refreshData"  @pulling-up="loadMoreData">
	      		<div class="order-list my-order">
                    <order-buy v-for="o in order" :order="o" @noticeParent="removeOrder" :index="0" :searchForm="searchForm"></order-buy>
                    <div class="order-noData" v-if="order.length<1">暂无待处理订单</div>
				</div>
	      	</cube-scroll>
		</cube-slide-item>
		    <cube-slide-item>
		      <cube-scroll>
	      		<div class="order-list my-order">
                      <div class="topimg">
						  <div class="img"></div>
                          <!-- <img class="img" :src="require('@/assets/images/sale_pic.png')" alt=""> -->
                      </div>
                      <div class="desc">系统会自动与您的钱包余额匹配派发订单</div>
                      <div><button type="button" class="btnGo" @click="goSellOrder">查看我的出售订单</button></div>
				</div>
	      	</cube-scroll>
		</cube-slide-item>
	 </cube-slide>
  </div>
</template>

<script>
import orderBuy from "@/components/orderbuy.vue"
export default {
  name: 'market',
  data(){
  	return {
  		currentStatus:1,
  		crtIndex:0,
  		status:[1,2],
		txts:['购买','出售'],
  		scrollOptions:this.$store.state.refreshOptions,
  		order:[],
  		pageIndex:1,
		  payTypeOptions:[
			{
				value:-1,
				text:'全部'
			},
			{
				value:1,
				text:'银行卡'
			},
			{
				value:2,
				text:'支付宝'
			},
		],
		searchForm:{
			payType:-1,
			minCNY:'',
			maxCNY:''
		}
	  }
	 
  },
  components:{
  	orderBuy:orderBuy
  },
  methods:{
  	changeNav(sta){
  		this.status.some((v,i) => {
  			if(v == sta){
  				this.crtIndex = i
  				return true
  			}
  		})
  	},
  	changeSlide(idx){
		  let that=this;
		  //设置当前的Status值
		  that.currentStatus = that.status[idx];
		  this.searchForm = {
			payType:-1,
			minCNY:'',
			maxCNY:''
		}
  	},
	setParam(){//设置请求参数
		let that=this;
		var param={
			  pageSize:10,
			  pageIndex:that.pageIndex
		  }
		return param;
	},
  	getOrders(refreshPage){
	    let that=this;
		let data=that.setParam();
		if(refreshPage == 1){
			data.pageIndex= 1;  //设置当前页面的页码参数
			this.order = []
		}
		
		if(that.searchForm.payType !== -1){
			data.payType =  that.searchForm.payType 
		}
		if(that.searchForm.minCNY){
			data.minCNY = Number(that.searchForm.minCNY)
		}
		if(that.searchForm.maxCNY){
			data.maxCNY = Number(that.searchForm.maxCNY)
		}
        that.$api.getBuyOrders(data).then((res) => {
			var data=res.data
			//后台传过来页码要存储在  that['page'+type] 之中
			that.order = that.order.concat(data.Items);
			if(that.pageIndex>data.TotalPages){
					that.$refs['scrollF'].forceUpdate();
				}else{
					that.pageIndex ++;
				}  
  			})
	  },
	removeOrder(orderId){
		var orders= this.order;
		for (let i = 0; i < orders.length; i++) {
			var order=orders[i];
			if(order.OrderId===orderId){
				this.order.splice(order, 1);
				break;
			}
		}
	},
  	refreshData(){
		this.getOrders();
	},
  	loadMoreData(){
		this.getOrders();
    },
    goSellOrder(){//跳转到我的订单中
        this.$store.commit('setParam',{
                name:'menu',
                prop:'active',
                value:"order"
		})

		this.$store.commit('storeParams',{
			name:"orderTab",
			view:"order"
		})
        this.$router.push({ name: "order" });
    }
  },
  created(){
	let that=this;
	that.$parent.active=that.$store.state.routerStore.menu.active;
	if(that.$store.state.routerStore.orderDetails){
		that.searchForm = that.$store.state.routerStore.orderDetails.searchForm
	}
	that.getOrders();
  }
}
</script>

<style lang="less" scoped>
	.order-scroll{
		height: calc(100% - 115px);
    }
    .topimg{
       .img{
           margin: 0 auto;
		   width: 40%;
		   background: url(../assets/images/sale_pic.png) center center no-repeat;
		   background-size: 100%;
    	   height: 110px;
       }
    }
    .desc{
        text-align:center;
        color:#fff;
        margin:30px 0;
    }

  .btnGo{
        color: #fff;
        background-color: #00a0de;
        box-shadow: 0px 1px 3px 0px rgba(0, 1, 1, 0.4);
        border-radius: 5px;
        width: 100%;
        padding: 10px;
        font-size:16px !important;
        }
</style>